import type { CarImage, CarImageSize, ImageGroup } from '@autobid/ui/types/Car'

export function replaceImageSize(image: string, sourceSize: CarImageSize, targetSize: CarImageSize) {
  return image.replace(`_${sourceSize}`, `_${targetSize}`)
}

export function generateImageSizesFromArray(fromSize: CarImageSize, images: CarImage[]): CarImage[] {
  const SIZES: CarImageSize[] = ['hd', 'l', 'm', 's', 'xs']

  return images.map((image) => {
    return {
      ...image,
      links: SIZES.reduce((acc: CarImage['links'], size) => {
        acc[size] = replaceImageSize(image.links.hd, fromSize, size)

        return acc
      }, {} as CarImage['links']),
    }
  })
}

export function generateImageSizesFromObject(fromSize: CarImageSize, data: Record<ImageGroup, CarImage[]>) {
  return Object.entries(data).reduce((acc: Record<ImageGroup, CarImage[]>, el) => {
    const group = el[0] as ImageGroup

    acc[group] = generateImageSizesFromArray(fromSize, el[1])

    return acc
  }, {} as Record<ImageGroup, CarImage[]>)
}
